<template>
  <div class="pa-0 ma-0">
    <label style="color:grey;">{{ fieldLabel }}</label>

    <v-text-field
      v-model="extraFieldsValue.value"
      dense
    />

  </div>
</template>
<script>
export default {
  name: 'Textline',
  props: {
    isrequired: {
      type: Boolean,
      default: false
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    extraFieldsValue: {
      type: Object,
      default: () => { return {} }

    }
  },
  data () {
    return {

    }
  }

}
</script>
